import { appInject, appInjectable } from "@core/di/utils";
import { BaseService } from "@core/services/base";
import { DI_TOKENS } from "@shared/constants/di";
import { IConfigService } from "@shared/interfaces/config-service.interface";
import { IHttpClientService } from "@shared/interfaces/http-client-service.interface";
import { ICampaignPromoCodesService } from "@shared/interfaces/campaign-promo-codes-service.interface";
import {
  CampaignPromoCodeDto,
  CampaignPromoCodesListDto,
} from "@shared/types/campaign-promo-codes/campaign-promo-code.dto";
import {
  downloadBlob,
  getFilenameFromContentDisposition,
} from "@shared/utils/download-blob";

@appInjectable()
export class CampaignPromoCodesService
  extends BaseService
  implements ICampaignPromoCodesService
{
  private configService = appInject<IConfigService>(DI_TOKENS.configService);
  private httpClient = appInject<IHttpClientService>(
    DI_TOKENS.httpClientService,
  );
  private baseURL: string;

  constructor() {
    super();
    this.baseURL = this.configService.baseUrl;
  }

  list: ICampaignPromoCodesService["list"] = async (params) => {
    const { withCpaRedemption, ...rest } = params;
    const { data } = await this.httpClient.get<{
      data: CampaignPromoCodesListDto;
    }>("/campaign-promo-codes", {
      params: {
        ...rest,
        ...(withCpaRedemption ? { withCpaRedemption: "true" } : {}),
      },
      baseURL: this.baseURL,
    });
    return data.data;
  };

  exportCsv: ICampaignPromoCodesService["exportCsv"] = async (params) => {
    const { withCpaRedemption, ...rest } = params;
    const response = await this.httpClient.get<Blob>("/campaign-promo-codes/export", {
      params: {
        ...rest,
        ...(withCpaRedemption ? { withCpaRedemption: "true" } : {}),
      },
      baseURL: this.baseURL,
      responseType: "blob",
    });
    const contentDisposition =
      "headers" in response
        ? (response.headers["content-disposition"] as string | undefined)
        : undefined;
    const filename = getFilenameFromContentDisposition(
      contentDisposition,
      `promo-codes-${new Date().toISOString().slice(0, 10)}.csv`,
    );
    downloadBlob(response.data, filename);
  };

  create: ICampaignPromoCodesService["create"] = async (body) => {
    const { data } = await this.httpClient.post<{
      data: CampaignPromoCodeDto[];
    }>("/campaign-promo-codes", body, { baseURL: this.baseURL });
    return data.data;
  };
}
